import { render, staticRenderFns } from "./MitAdminApiPage.vue?vue&type=template&id=a8fd4e86&scoped=true"
import script from "./MitAdminApiPage.vue?vue&type=script&lang=js"
export * from "./MitAdminApiPage.vue?vue&type=script&lang=js"
import style0 from "./MitAdminApiPage.vue?vue&type=style&index=0&id=a8fd4e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fd4e86",
  null
  
)

export default component.exports